import { render, staticRenderFns } from "./PendingActionModal.vue?vue&type=template&id=74010dbd&"
import script from "./PendingActionModal.vue?vue&type=script&lang=js&"
export * from "./PendingActionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74010dbd')) {
      api.createRecord('74010dbd', component.options)
    } else {
      api.reload('74010dbd', component.options)
    }
    module.hot.accept("./PendingActionModal.vue?vue&type=template&id=74010dbd&", function () {
      api.rerender('74010dbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/Access/Pending/PendingActionModal.vue"
export default component.exports